import { logger } from '@zep/core-logger';

import { useOpenWindow } from '@/hooks';

type UpsellUpgradeEvent =
  | 'click_ai_tutor_upselling_upgrade'
  | 'click_feature_upselling_upgrade';

/**
 * PRO 업그레이드 진입을 한 곳에서 처리한다 (트래킹 + /pricing 새창).
 * 호출부마다 흩어져 있던 `logger.track` + `openWindow('/pricing')` 중복과
 * 로거 import 불일치를 제거한다.
 */
export const useUpgradeToPro = () => {
  const openWindow = useOpenWindow();

  return (event: UpsellUpgradeEvent, from: string) => {
    logger.track(event, { from });
    openWindow('/pricing');
  };
};
